import storageSession from 'redux-persist/lib/storage/session'

export const persistConfig = {
	key: 'root',
	// localStorage에 저장합니다.
	storage: storageSession,
	// 저장할 리스트
	whitelist: [
		// core
		'config',
		'route',
		'auth',
		'user',
		'department',
		'main',
		'grid',

		// main
		'admin',
		'logDashboard',
		'accessPolicy',
		'accessControl',
		'product',
		'season',
		'coupon',
		'customer',
		/*
			⚠ `order` 는 일부러 뺐다 (2026-09-20 운영 사고).
			저장된 상태를 되살리면 **배포로 상태가 늘어났을 때 지난 세션에는 그 키가 없다** — 새 코드가
			`undefined` 를 읽고 화면이 통째로 죽었다(`detailOrder.id`). 목록·검색조건은 화면에 들어올 때
			어차피 다시 읽으므로 세션에 남길 이유가 없다. 다른 슬라이스에 같은 일이 생기면 여기서 뺀다.
		*/

		// home
		'customerAuth',
		'shop',
		'cart',
		'payment',
		'inquiry',
	],
	blacklist: ['login'],
}
